import { styled } from '@mui/system'
import Typography from '../../atoms/typography'
import BHRangeSlider from '../range-slider'
import BHSwatch from '../swatch'
import BHButton from '../button'

const Root = styled('div')`
	.MuiAccordionSummary-root {
		padding: 0;
	}
`

const Title = styled(Typography)`
	> span:last-of-type:not(:only-of-type) {
		${({ theme }) => theme.typography.body1};
	}
`

const BorderIcon = styled('div')`
	border: 0;
	border-radius: 50%;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--color-primary);
	.MuiSvgIcon-root {
		font-size: ${({ theme }) => theme.typography.pxToRem(24)};
	}
`

const Swatch = styled(BHSwatch)`
	width: 16px;
	height: 16px;
	border-radius: 2px;
	padding: 1px;
	border: 1px solid transparent;
	margin-top: 3px;
	transition: border-color 0.2s;
	+ .MuiTypography-root {
		margin-left: 6px;
		color: ${({ disabled, theme }) => (disabled ? theme.palette.grey.light : theme.palette.primary.main)};
		cursor: pointer;
	}

	&:not(.with-border) span {
		border: none;
	}

	&.Mui-selected,
	&:hover {
		border-color: var(--color-primary);
	}
`

const ButtonMoreFilters = styled(BHButton)`
	margin-top: 40px;
	width: 100%;
`

const RangeSlider = styled(BHRangeSlider)`
	position: relative;
	width: calc(100% - 5px);
	.MuiSlider-track {
		display: block;
	}
	.MuiSlider-valueLabel {
		top: -5px;
	}
`

const SwatchRoot = {
	sx: {
		marginBottom: '16px',
		':last-child': {
			marginBottom: '0',
		},
	},
}

export { Root, Title, BorderIcon, Swatch, ButtonMoreFilters, RangeSlider, SwatchRoot }
